// extracted by mini-css-extract-plugin
module.exports = {"EventOriginIcon":"EventOriginIcon--2cou6"};